<template>
  <div class="unavailable">
    <div class="unavailable-card">
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
      <h2>{{ title }}</h2>
      <p>{{ reason }}</p>
      <p class="unavailable-plan">
        Esta tela volta assim que o WootDash tiver o equivalente.
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ title?: string; reason?: string }>(), {
  title: 'Indisponível nesta fase',
  reason:
    'O Chatwoot saiu de circulação e esta tela ainda depende de dados que só existiam lá. ' +
    'Fica de fora até o WootDash ter um equivalente de verdade.',
})
</script>

<style scoped>
.unavailable {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 24px;
}
.unavailable-card {
  max-width: 440px;
  text-align: center;
  color: var(--ink-60, #4b5563);
}
.unavailable-card svg {
  color: var(--ink-40, #9ca3af);
  margin-bottom: 14px;
}
.unavailable-card h2 {
  font-size: 17px;
  color: var(--ink-80, #1f2937);
  margin: 0 0 10px;
}
.unavailable-card p {
  font-size: 13.5px;
  line-height: 1.6;
  margin: 0 0 8px;
}
.unavailable-plan {
  font-size: 12px;
  color: var(--ink-40, #9ca3af);
}
.unavailable-plan code {
  background: #f3f4f6;
  padding: 1px 6px;
  border-radius: 5px;
}
</style>
